{
  "VALIDATION_FAILED": "البيانات المرسلة غير صالحة",
  "USERNAME_TAKEN": "اسم المستخدم هذا مستخدم بالفعل",
  "SYSTEM_EXISTS": "يوجد نظام بهذا الرمز بالفعل",
  "NO_PLATFORM_ACCESS": "ليس لديك صلاحية الوصول إلى هذا النظام",
  "UA_UNAVAILABLE": "تعذر الوصول إلى الدخول الموحد. أعد المحاولة بعد قليل.",
  "INTEGRATION_UNAUTHORIZED": "بيانات اعتماد التكامل غير صالحة",
  "UNAUTHENTICATED": "يجب تسجيل الدخول",
  "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "FORBIDDEN": "ليس لديك صلاحية لتنفيذ هذا الإجراء",
  "NOT_FOUND": "العنصر المطلوب غير موجود",
  "CONFLICT": "تعارض في البيانات. أعد تحميل البيانات الحالية.",
  "UNIQUE_VIOLATION": "هذه القيمة مستخدمة بالفعل",
  "FOREIGN_KEY_VIOLATION": "هذا العنصر مرتبط بعناصر أخرى ولا يمكن حذفه",
  "RATE_LIMITED": "عدد كبير جدا من المحاولات. أعد المحاولة بعد قليل.",
  "IDEMPOTENCY_KEY_REUSED": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "REQUEST_IN_PROGRESS": "لا يزال هذا الطلب قيد المعالجة",
  "PAYLOAD_TOO_LARGE": "البيانات المرسلة تتجاوز الحجم المسموح به",
  "UNPROCESSABLE": "تعذرت معالجة الطلب. تحقق من البيانات المرسلة.",
  "INTERNAL_ERROR": "تعذر إكمال العملية. أعد المحاولة أو تواصل مع المسؤول.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة حاليا. أعد المحاولة بعد قليل.",
  "network": "تعذر الاتصال بالخادم. تحقق من اتصالك وأعد المحاولة.",
  "timeout": "لم نتمكن من تأكيد اكتمال العملية. تحقق من الحالة الحالية قبل إعادة المحاولة.",
  "IDEMPOTENCY_CONFLICT": "تم استخدام مفتاح الطلب نفسه لطلب مختلف",
  "TABLET_NOT_AVAILABLE": "جهاز التابلت غير متاح في هذا الفرع",
  "TABLET_BUSY": "التابلت مشغول",
  "TABLET_PAIRING_CODE_INVALID": "رمز الربط غير صحيح أو انتهت صلاحيته",
  "TABLET_UNAUTHENTICATED": "هذا الجهاز غير مربوط",
  "TABLET_INACTIVE": "جهاز التابلت معطل",
  "TASK_CLOSED": "انتهت هذه العملية",
  "TASK_NOT_SUBMITTED": "لم يوقع العميل بعد",
  "SIGNATURE_REQUIRED": "التوقيع مطلوب",
  "LINK_INVALID": "انتهى هذا الطلب ولم يعد متاحا",
  "LINK_UNAVAILABLE": "تعبئة البيانات على جهاز الموظف غير متاحة حاليا"
}
